export const RECEIVE_NEWS_CONTENT_LIST = 'RECEIVE_NEWS_CONTENT_LIST';
export const UPDATE_NEWS_CONTENT = 'UPDATE_NEWS_CONTENT';
export const CANCEL_NEWS_UPDATE = 'CANCEL_NEWS_UPDATE';
export const SAVE_NEWS_CONTENT = 'SAVE_NEWS_CONTENT';
export const PERSIST_NEWS_CONTENT = 'PERSIST_NEWS_CONTENT';
export const DELETE_NEWS_CONTENT = ' DELETE_NEWS_CONTENT';
export const CREATE_NEWS_CONTENT = 'CREATE_NEWS_CONTENT';
export const RESET_CREATE_NEWS_CONTENT = 'RESET_CREATE_NEWS_CONTENT';
export const ADD_NEWS_TO_LIST = 'ADD_NEWS_TO_LIST';

